//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderView } from '@/api/integralmall'
import { viewLogistics, viewCompany, viewexpressName } from '@/api/mall'
import config from '@/config/index'
export default {
  name: 'logistics',
  props: {},
  data () {
    return {
      id: this.$route.params.orderid,
      baseUrl: config.baseUrl,
      Traceslist: '',
      length: '',
      obj: {
        TITLEIMG: '',
        STATUSIDNAME: '',
        ORDERCODE: ''
      },
      code: '',
      reason: ''
    }
  },
  created () {
    this.getOrderViewNow()
  },
  mounted () { },
  methods: {
    getcompany () {
      viewCompany({
        EXPRESSCODE: this.code
      }).then(res => {
      })
    },
    getOrderViewNow () {
      let _this = this
      getOrderView({
        orderid: this.id
      }).then(data => {
        _this.obj = data.returnValue
        this.code = data.returnValue.EXPCODE.replace(/[^a-zA-Z]/g, '')
        if (this.code == '') {
          this.getcode(data.returnValue.EXPNAME)
        } else {
          this.getlist()
        }
      })
    },
    getcode (name) {
      viewexpressName({
        expressName: name
      }).then(data => {
        this.code = data.obj.expressCode
        this.getlist()
      })
    },
    getlist () {
      var _this = this
      viewLogistics({
        pho: this.obj.MOBILE,
        expCode: this.code,
        expNo: this.obj.EXPCODE
      }).then(data => {
        // console.log(data.obj)
        _this.Traceslist = data.obj.Traces.reverse()
        _this.length = data.obj.Traces.length
        _this.reason = data.obj.Reason
      })
    },
    copycode () {
      const range = document.createRange()
      range.selectNode(document.querySelector('.wlcode'))
      const selection = window.getSelection()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('Copy')
      this.$vux.toast.text('复制成功')
    }
  }
}
